import { Link } from "react-router-dom";
import { Check, Mail, Phone } from "lucide-react";

// Page « Demande envoyée » du moteur "default" — composée avec les mêmes
// briques que la section Contact (sections/ContactSection.jsx) : conteneur
// 1240px, titre font-display, texte graphite, pictos or dans des carrés
// arrondis, carte blanche bordée, bouton encre. Tout passe par les jetons
// de palette / forme / espacement de la boutique (Studio de thème), si bien
// que chaque thème du moteur (Chocolatier, Barber, Assurance…) la recolore
// sans rien toucher ici. La garde d'accès et les données viennent de
// pages/ContactConfirmation.jsx.
export default function ContactConfirmationPage({ copy, name, message, email, phone, homeTo }) {
  const telHref = phone ? `tel:${phone.replace(/[^\d+]/g, "")}` : "";

  return (
    <section
      data-testid="contact-confirmation"
      className="max-w-[1240px] mx-auto px-6 md:px-10 pt-section-top md:pt-section-top-md pb-section-top animate-fade-up"
    >
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <span className="h-14 w-14 rounded-full bg-gold/15 flex items-center justify-center">
            <Check className="h-7 w-7 text-gold" strokeWidth={2.4} />
          </span>
          <p className="mt-6 text-[12px] uppercase tracking-[0.18em] font-semibold text-gold">{copy.eyebrow}</p>
          <h1 className="mt-3 font-display font-semibold text-[32px] md:text-[42px] leading-[1.1] tracking-[-0.02em] text-ink [text-wrap:pretty]">
            {name ? copy.titleNamed(name) : copy.title}
            {copy.titleAfter}
          </h1>
          <p
            data-testid="contact-confirmation-message"
            className="text-[17px] leading-relaxed text-graphite mt-4 max-w-md whitespace-pre-line"
          >
            {message}
          </p>
          <Link
            to={homeTo}
            data-testid="contact-confirmation-home"
            className="mt-9 inline-flex items-center justify-center px-8 py-3.5 rounded-btn bg-ink text-white text-[14px] font-semibold hover:opacity-90 transition-opacity"
          >
            {copy.home}
          </Link>
        </div>

        <div className="rounded-card border-control border-stone bg-white p-6 md:p-8">
          <h2 className="font-display font-semibold text-[20px] text-ink">{copy.stepsTitle}</h2>

          <ol className="mt-6">
            {copy.steps.map((step, i) => {
              const done = i === 0;
              const last = i === copy.steps.length - 1;
              return (
                <li key={step.title} className="flex gap-4">
                  {/* Pastille + trait vertical qui la relie à la suivante —
                      mêmes repères que les étapes de ContactQuoteStepper. */}
                  <div className="flex flex-col items-center">
                    <span
                      className={`h-8 w-8 rounded-full flex items-center justify-center text-[13px] font-semibold shrink-0 border-2 ${
                        done ? "bg-gold border-gold text-white" : "border-stone text-ash"
                      }`}
                    >
                      {done ? <Check className="h-4 w-4" /> : i + 1}
                    </span>
                    {!last && <span className={`w-[2px] flex-1 my-1.5 rounded-full ${done ? "bg-gold" : "bg-stone"}`} />}
                  </div>
                  <div className={last ? "pt-1" : "pt-1 pb-6"}>
                    <p className="text-[15px] font-medium text-ink">{step.title}</p>
                    <p className="text-[14px] text-graphite mt-0.5">{step.text}</p>
                  </div>
                </li>
              );
            })}
          </ol>

          {(email || phone) && (
            <div className="mt-7 pt-6 border-t border-stone">
              <p className="text-[11px] uppercase tracking-[0.15em] text-ash mb-3">{copy.urgent}</p>
              <div className="space-y-3">
                {email && (
                  <a href={`mailto:${email}`} className="flex items-center gap-3 text-[15px] text-ink hover:text-gold transition-colors break-all">
                    <span className="h-9 w-9 shrink-0 rounded-btn bg-white border-control border-stone flex items-center justify-center"><Mail className="h-4 w-4 text-gold" /></span>
                    {email}
                  </a>
                )}
                {phone && (
                  <a href={telHref} className="flex items-center gap-3 text-[15px] text-ink hover:text-gold transition-colors">
                    <span className="h-9 w-9 shrink-0 rounded-btn bg-white border-control border-stone flex items-center justify-center"><Phone className="h-4 w-4 text-gold" /></span>
                    <span dir="ltr">{phone}</span>
                  </a>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
